import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import LocalStorageUtility from '@/utils/localStorage';
import { LocalStorageKeys } from 'src/enums/ELocalStorage';

export interface ResellerOnboardingState {
	email: string;
	businessName: string;
	country: string;
	password: string;
	firstName: string;
	lastName: string;
	registerationCompleted?: boolean;
	testingCompleted?: boolean;
	currentStep: number;
	desiredCountry?: string;
	testedReceptionist?: 'yes' | 'no';
	id: string;
	token?: string;
	clientsCount?: number;
	businessType?: string;
	businessRevenue?: string;
	businessEmployeeSize?: string;
	businessWebsite?: string;
	planToSell?: string;
	premiumPartnershipCommitment?: 'yes' | 'no';
}

const initialState: ResellerOnboardingState = {
	id: '',
	email: '',
	businessName: '',
	country: '',
	password: '',
	firstName: '',
	lastName: '',
	registerationCompleted: false,
	testingCompleted: false,
	currentStep: 1,
	desiredCountry: '',
	clientsCount: undefined,
	businessType: undefined,
	businessRevenue: undefined,
	businessEmployeeSize: undefined,
	businessWebsite: undefined,
	planToSell: undefined,
	premiumPartnershipCommitment: undefined,
};

const resellerOnboardingSlice = createSlice({
	name: 'resellerOnboarding',
	initialState,
	reducers: {
		setOnboardingInfo: (
			state: ResellerOnboardingState,
			action: PayloadAction<Partial<ResellerOnboardingState>>,
		) => {
			const updatedState = { ...state, ...action.payload };
			console.info('updatedState', updatedState);
			LocalStorageUtility.setLocalData(LocalStorageKeys.RESELLER_ONBOARDING, updatedState);
			return updatedState;
		},
		updateOnboardingInfo: (
			state: ResellerOnboardingState,
			action: PayloadAction<Partial<ResellerOnboardingState>>,
		) => {
			const updatedState = { ...state, ...action.payload };
			console.info('updatedState', updatedState);
			LocalStorageUtility.setLocalData(LocalStorageKeys.RESELLER_ONBOARDING, updatedState);
			return updatedState;
		},
		nextStep: (state: ResellerOnboardingState) => {
			state.currentStep = state.currentStep + 1;
			LocalStorageUtility.setLocalData(LocalStorageKeys.RESELLER_ONBOARDING, state);
		},
		setStep: (state: ResellerOnboardingState, action: PayloadAction<number>) => {
			state.currentStep = action.payload;
			LocalStorageUtility.setLocalData(LocalStorageKeys.RESELLER_ONBOARDING, state);
		},
		unsetOnboardingInfo: () => {
			LocalStorageUtility.removeLocalData(LocalStorageKeys.RESELLER_ONBOARDING);
			return { ...initialState };
		},
	},
});

export const { setOnboardingInfo, updateOnboardingInfo, unsetOnboardingInfo, nextStep, setStep } =
	resellerOnboardingSlice.actions;

export default resellerOnboardingSlice.reducer;
